'use client';

import { useEffect } from 'react';
import { useParams, usePathname, useRouter } from 'next/navigation';
import { denormalizeLocale, normalizeLocale, type Locale } from '@/i18n/config';

export type CatalogLanguageMode = 'user' | Locale;

export function CatalogLanguageForcer({ mode }: { mode: CatalogLanguageMode }) {
  const router = useRouter();
  const pathname = usePathname();
  const params = useParams();

  useEffect(() => {
    if (mode === 'user' || !pathname) {
      return;
    }

    const currentLocaleParam = params?.locale as string | undefined;
    const currentLocale = currentLocaleParam
      ? denormalizeLocale(currentLocaleParam)
      : null;

    if (currentLocale === mode) {
      return;
    }

    const segments = pathname.split('/').filter(Boolean);
    segments[0] = normalizeLocale(mode);
    router.replace('/' + segments.join('/'));
  }, [mode, pathname, params, router]);

  return null;
}
